import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * Retrieves the height of the header section
 * Can include the impersonate banner height if present.
 *
 * @returns {string} The height of the header in pixels.
 */
export const getHeaderHeight = (): string => {
  const headerElement = inject(DOCUMENT).querySelector('.main-container__header-section');

  if (!headerElement) {
    return '0px';
  }

  return `${headerElement.clientHeight}px`;
};
